import styled from 'styled-components';

const StyledContainer = styled.div`
	margin-top: 34px;
	padding: 0 30px;
`;

const StyledTable = styled.table`
	width: 100%;

	thead {
		tr {
			border-bottom: 1px solid rgba(0, 0, 0, 0.1);

			th {
				padding-bottom: 17px;
				font-family: 'GT Walsheim Pro';
				font-style: normal;
				font-weight: 400;
				font-size: 12px;
				line-height: 14px;
				color: #000000;
				opacity: 0.25;
				user-select: none;
				pointer-events: none;

				&:nth-child(1) {
					text-align: left;
				}

				&:nth-child(3) {
					text-align: right;
				}
			}
		}
	}
`;

const StyledTr = styled.tr`
	border-bottom: 1px solid rgba(0, 0, 0, 0.1);

	td {
		padding: 17px 0;

		&:nth-child(2) {
			text-align: center;
		}

		&:nth-child(3) {
			text-align: right;
		}
	}
`;

const StyledDivider = styled.div`
	width: 100%;
	height: 1px;
	background-color: rgba(0, 0, 0, 0.1);
`;

export { StyledContainer, StyledTable, StyledDivider, StyledTr };
